import React from "react";
import ReactDOM from "react-dom";
import styled from "@emotion/styled";
import 'react-dates/initialize';
import { DayPickerRangeController } from "react-dates";
import { START_DATE, END_DATE, HORIZONTAL_ORIENTATION, VERTICAL_ORIENTATION, VERTICAL_SCROLLABLE } from "react-dates/constants";
import { Box } from "./Box.js";
import moment from "moment";
import colors from '../../../sass/brand_palette.scss';
import additionalfn from '../../_additionalfn';
import validPeriods from '../../front/calendar/validPeriods.js';
import { CloseButton } from './CloseButton';
import { SearchIcon } from './SearchIcon';
import { SelectClearButton } from "./SelectClearButton";
import { Mask } from "./Mask";

// Needed to style react dates
import { withStyles, css } from "react-with-styles";
//import ThemedStyleSheet from "react-with-styles/lib/ThemedStyleSheet";
//import aphroditeInterface from "react-with-styles-interface-aphrodite";
//import CVCalendarTheme from "./style/CVMobilescrollCalendarTheme";
import 'react-dates/lib/css/_datepicker.css';
import './style/Datepicker-reactdates/styles.scss';
import withTranslator from "../Translator/withTranslation";
import { compose } from "recompose"

//ThemedStyleSheet.registerInterface(aphroditeInterface);
//ThemedStyleSheet.registerTheme(CVCalendarTheme);

const MINIMUM_STAY_LIMIT = 3;
const ARRIVAL_OFFSET = 3;

const DateContainer = styled.div`
    display: flex;
    flex-direction: row;
    position: relative;
    @media (max-width: 576px) {
        gap:0.5rem;
    }
`;

const ChevronUpStart = styled.div`
    width: 0;
    height: 0;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-bottom: 12px solid #fff;
    border-radius: 0px;
    background: none;
    position:absolute;
    left: calc(50% - 8px);
`;
const ChevronUpEnd = styled.div`
    width: 0;
    height: 0;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-bottom: 12px solid #fff;
    border-radius: 0px;
    background: none;
    position:absolute;
    left: calc(50% - 8px);
`;

const FakeSelect = styled.div`
    background-color: white;
    color: ${({ selected }) => (selected ? colors.blue1 : colors.grey1)};
`;

const DatePickerHolder = styled.div`
    position: absolute;
    z-index: 100;
    top: 60px;
    left: ${({ focusedInput, holderWidth }) => {
      const leftPx =
        focusedInput === START_DATE ? 0 : 'auto';
      return `${leftPx}`;
    }};
    right: ${({ focusedInput, holderWidth }) => {
      const leftPx =
        focusedInput === START_DATE ? 0 : 'auto';
      return `${leftPx}`;
    }};
`;

const DatePickerHolderMobile = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index:300;

    @media (min-width:601px) and (max-width:767px){
        width:auto;
        left: ${({ focusedInput, holderWidth }) => {
            const leftPx =
              focusedInput === START_DATE ? 0 : 'auto';
            return `${leftPx}`;
        }};
        right: ${({ focusedInput, holderWidth }) => {
            const leftPx =
              focusedInput === START_DATE ? 'auto' : 0;
            return `${leftPx}`;
        }};
    }
`;

const TopCalendarContainer = styled.div`
    display:flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    width: 100%;
    z-index: 3;
    background: #fff;
`;

const CenterInfoContainer = styled.div`
    text-transform:uppercase;
    color:${colors.black};
    display:inline-block;
    padding:10px 10px 10px 17px;
    font-weight:600;
`;

class DatepickerRangeComponent extends React.Component {
    constructor(props) {
        super(props);

        this.startRef = React.createRef();
        this.endRef = React.createRef();
        this.dpRef = React.createRef();

        this.state = {
            focusedInput: null,
            holderWidth: null,
            hidePrev: false,
            hideNext: false,
            minimumNights: MINIMUM_STAY_LIMIT,
        };
        
        this.closeCalendar = this.closeCalendar.bind(this);
        let momentLocale = props.locale;
        if (momentLocale == 'ca_es') {
            momentLocale = 'ca';
        }
        moment.locale(momentLocale);
    }
    
    checkMonthButtonVisibility = (visibleMonth) => {
        var now = new Date(visibleMonth.year(),visibleMonth.month(),visibleMonth.date()),
            nextMonth = new Date(now.getFullYear(), now.getMonth()+1, 1),
            previousMonth = false,
            hidePrev = false,
            hideNext = false;
        
        now.setDate(0);
        previousMonth = now;
        
        if(this.isOutsideRange(previousMonth, 'newdate')) hidePrev = true;
        if(this.isOutsideRange(nextMonth, 'newdate')) hideNext = true;
        
        this.state = {
            hidePrev: hidePrev,
            hideNext: hideNext
        };
        
        this.hideNavigation();
    }
    
    closeCalendar = () => {
        this.setState({
            focusedInput: null
        });
    }
    
    componentDidMount = () => {
      this.setState({
        holderWidth: ReactDOM.findDOMNode(
          this.startRef.current
        ).getBoundingClientRect().width
      });
    }
    
    hideNavigation = () => {
        // for mobile we don't want to do anything
        if (this.props.mobile) {
            return;
        }
        const prevBtn = document.querySelectorAll("[class^=DayPickerNavigation_button]")[0];
        const nextBtn = document.querySelectorAll("[class^=DayPickerNavigation_button]")[1];
        
        if(prevBtn == undefined){
            setTimeout(
                function() {
                    this.hideNavigation()
                }
                .bind(this),
                100
            );
    
            return;
        }
        
        prevBtn.style.visibility = 'initial';
        nextBtn.style.visibility = 'initial';
        
        if(this.state.hidePrev){ 
            prevBtn.style.visibility='hidden';
        }
        if(this.state.hideNext){ 
            nextBtn.style.visibility='hidden';
        }
    }
    
    isDayBlocked = (day) => {
        
        if (day.day() === 6) return false; // is a saturday
        
        var startPeriod = false,
            endPeriod = false,
            dayFormatted = additionalfn.formatDate({
                year: day.year(),
                month: day.month(),
                day: day.date()
            }),
            inRange = 0;
        
        for(var i in this.validPeriods()){
            if(dayFormatted >= this.validPeriods()[i].start && dayFormatted <= this.validPeriods()[i].end) inRange++;
        }
        
        if(inRange > 0) return false; // is in valid periods
        
        return true; // day should be blocked
    }
    
    isOutsideRange = (date, format) => {
        var currentdate = additionalfn.today(),
            offsetDate = additionalfn.todayWithOffset((this.props.arrivalOffset >= 0) ? 0 : ARRIVAL_OFFSET),
            checkStart = additionalfn.formatDate({
                year: format === 'moment' ? date.year() : date.getFullYear(),
                month: format === 'moment' ? date.month() : date.getMonth(),
                day: format === 'moment' ? date.date() : date.getDate()
            }),
            lastValidDay = 0;
        
        if (checkStart < offsetDate) {
            return true;
        }

        if(checkStart < currentdate) { // past dates
            return true;
        }

        for(var i in this.validPeriods()){
            if(lastValidDay <this.validPeriods()[i].end) lastValidDay = this.validPeriods()[i].end;
        }

        if(checkStart > lastValidDay){ // post last valid day
            return true;
        }
    }

    onDatesChange = ({ startDate, endDate }) => {
        if(startDate !== this.props.startDate) this.props.onChangeStartDate(startDate);
        if(endDate !== this.props.endDate) this.props.onChangeEndDate(endDate);
    }
    
    onFocusChange = focusedInput => {
        this.setState({
            focusedInput: focusedInput
        });
        if (focusedInput === null) {
            window.scrollTo(0,0);
            return;
        }
        if (this.props.mobile) {
            var that = this;
            setTimeout( function () {
                var monthsToScroll = (moment().month() <= 6) ? 6 - moment().month() : 18 - moment().month();
                var container = ReactDOM.findDOMNode(that.dpRef.current);
                if (container) {
                    var monthGrid = container.children[0].children[1].children[1].children[0].children[1];
                    if ((focusedInput === 'startDate' || focusedInput === 'endDate' ) && that.props.startDate && that.props.endDate) {
                        monthsToScroll = that.props.startDate.diff(moment(), 'months');
                    } else if (focusedInput === 'endDate' && that.props.startDate) {
                        monthsToScroll = that.props.startDate.diff(moment(), 'months');
                    }
                    if (monthGrid) {
                        monthGrid.parentNode.scrollTop = monthsToScroll * monthGrid.children[2].offsetHeight + 90;
                    }
                }
            }.bind(that), 750);
        }
    }
    
    renderCalendarInfo = (mobile,focusedInput) => { 
        const { t } = this.props;

        if(mobile){
            return (
            <TopCalendarContainer>
                <CenterInfoContainer>
                {t(focusedInput === 'startDate' ? 'select_arrival_date' : 'select_departure_date')}
                </CenterInfoContainer>
                <CloseButton 
                onClick={this.closeCalendar}
                />
            </TopCalendarContainer>
            );
        }
    }
    
    selectVisibleMonth = () => { 
        const { focusedInput } = this.state;
        const { startDate, endDate} = this.props;
        
        var highlightedMonthId = 6,
            currentMonthId = moment().month(),
            visibleMonth = moment().month(currentMonthId); // current month
        
        if(focusedInput === 'startDate' && startDate){ // start show selected month
            visibleMonth = startDate;
        } else if(focusedInput === 'endDate' && endDate){ // end show selected month
            visibleMonth = endDate;
        } else if(focusedInput === 'endDate' && !endDate && startDate){ // align end date with start when empty
            visibleMonth = startDate;
        } else if(moment().month() < highlightedMonthId){ // return highlightedMonth if current anterior
            visibleMonth = moment().month(highlightedMonthId);
        } else if(moment().month() > (highlightedMonthId+1)){ // next year highlighted month
            visibleMonth = moment().month(highlightedMonthId+12);
        }
        // if we have mobile we just want to return current month because we've enabled scrolling
        if (this.props.mobile) {
            visibleMonth = moment().month(currentMonthId);
        }
        this.checkMonthButtonVisibility(visibleMonth);

        return visibleMonth;
    }
    
    validPeriods = () => {
        var formattedArray = [];
        
        for(var i in validPeriods){
            formattedArray.push(
                {
                    start: additionalfn.formatDate({
                        year: validPeriods[i].start.getFullYear(),
                        month: validPeriods[i].start.getMonth(),
                        day: validPeriods[i].start.getDate()
                    }),
                    end: additionalfn.formatDate({
                        year: validPeriods[i].end.getFullYear(),
                        month: validPeriods[i].end.getMonth(),
                        day: validPeriods[i].end.getDate()
                    })
                }
            );
        }
        
        return formattedArray;
    }
    
    render() {
        const { focusedInput, holderWidth } = this.state; 
        const { startDate, endDate, mobile, t, searchFormVariant } = this.props;
        const startDateString = startDate && startDate.format("DD-MM-YYYY");
        const endDateString = endDate && endDate.format("DD-MM-YYYY");
        const Holder = mobile ? DatePickerHolderMobile : DatePickerHolder;
        const calendarHolderClasses = (mobile) ? "calendarHolder mobile": "calendarHolder width-mcontent";
        const holderStyle = this.props.mobile ? {width: '100%'}: {};

        const clearStartDate = <SelectClearButton 
                          onChange={(startDate) => this.props.onChangeStartDate(startDate)}
                          clearable={this.props.clearable}
                          value={this.props.startDate}
                      />;
        
        const clearEndDate = <SelectClearButton 
                          onChange={(endDate) => this.props.onChangeEndDate(endDate)}
                          clearable={this.props.clearable}
                          value={this.props.endDate}
                      />;    

        return (
          <DateContainer>
            <Box flex={"1 1 1%"} pr={mobile ? "" : "8px"} className="FakeSelect relative">
                <FakeSelect
                  mobile={mobile}
                  ref={this.startRef}
                  key="FakeSelectStartDate"
                  selected={!!startDateString}
                  onClick={() => this.onFocusChange(START_DATE)}
                  className={(searchFormVariant == 'white' ? "border-radius-default bor-thin bor-blue1 bor-solid btn select " : "btn bor-no select")}
                >
                <div className="flex items-center relative"><SearchIcon src={this.props.iconSrc} show={this.props.withIcon} />{startDateString ? startDateString : t('arrival')}{clearStartDate}</div>
                {(focusedInput == 'startDate') && ( <div className="selected"></div> )}
                </FakeSelect>
                {focusedInput === 'startDate' && ( <ChevronUpStart elem={this.startRef} /> )}
                {this.props.disabled ?
                <Mask />
                :''}
            </Box>
            <Box flex={"1 1 1%"} pr={mobile ? "" : "8px"} className="FakeSelect relative">
                <FakeSelect
                  mobile={mobile}
                  ref={this.endRef}
                  key="FakeSelectEndDate"
                  selected={!!endDateString}
                  onClick={() => this.onFocusChange(END_DATE)}
                  className={(searchFormVariant == 'white' ? "border-radius-default bor-thin bor-blue1 bor-solid btn select" : "btn bor-no select")}
                >
                <div className="flex items-center relative"><SearchIcon src={this.props.iconSrc} show={this.props.withIcon} />{endDateString ? endDateString : t('departure')}{clearEndDate}</div>
                {(focusedInput == 'endDate') && ( <div className="selected"></div> )}
                </FakeSelect>
                {focusedInput === 'endDate' && ( <ChevronUpEnd elem={this.endRef} /> )}
                {this.props.disabled ?
                <Mask />
                :''}
            </Box>
            <Holder focusedInput={focusedInput} holderWidth={holderWidth} className={calendarHolderClasses} style={holderStyle}>
                {focusedInput !== null && (
                  <DayPickerRangeController
                        key="dprc"
                        ref={this.dpRef}
                        onDatesChange={this.onDatesChange}
                        onFocusChange={this.onFocusChange}
                        numberOfMonths={this.props.numberOfMonths ? this.props.numberOfMonths : 1}
                        focusedInput={focusedInput}
                        minimumNights={this.state.minimumNights}
                        isDayBlocked={day => this.isDayBlocked(day)}
                        isOutsideRange={(date) => this.isOutsideRange(date, 'moment')}
                        initialVisibleMonth={this.selectVisibleMonth}
                        onOutsideClick={() => this.onFocusChange(null)}
                        startDate={startDate}
                        endDate={endDate}
                        hideKeyboardShortcutsPanel={true}
                        onPrevMonthClick={(date) => this.checkMonthButtonVisibility(date)}
                        onNextMonthClick={(date) => this.checkMonthButtonVisibility(date)}
                        orientation={mobile ? VERTICAL_SCROLLABLE : HORIZONTAL_ORIENTATION }
                        calendarInfoPosition="top"
                        renderCalendarInfo={() => this.renderCalendarInfo(mobile,focusedInput)}
                        daySize={mobile ? 40 : 34}
                    />
                )}
                {this.props.disabled ?
                <Mask mobile={mobile} />
                :''}
            </Holder>
          </DateContainer>
        );
    }
}

export const DatepickerRange = compose(
    withStyles(({ reactDates: { color } }) => ({})),
    withTranslator
)(DatepickerRangeComponent);